import { WidgetsServicesReportListMain } from '@/widgets/services-report-list';

export const PagesServicesPhotoMain = () => <WidgetsServicesReportListMain reportType="PHOTO" />;
